import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class AppStartupTimingService {
    private startTime?: Date;

    setStartTime(startTime: Date): void {
        this.startTime = startTime;
    }

    getStartTime(): Date | undefined {
        return this.startTime;
    }
}
